import { useState } from 'react';

const mediaItems = [
  {
    title: '苍穹之刃·终章预告', meta: '动作巨制 / 即将上映', duration: '02:38', views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20action%20scene%20with%20dramatic%20warm%20amber%20lighting%2C%20epic%20fantasy%20battle%20aesthetic%2C%20soft%20coral%20gradients%2C%20movie%20theater%20atmosphere%2C%20professional%20film%20production%20look%20with%20rich%20textures&width=640&height=360&seq=media-01&orientation=landscape'
  },
  {
    title: '幕后花絮：暗夜追光者', meta: '独家探班 / 演员访谈', duration: '15:20', views: '89万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20behind%20the%20scenes%20shot%20with%20warm%20golden%20lighting%2C%20film%20set%20atmosphere%2C%20soft%20coral%20and%20amber%20tones%2C%20professional%20production%20environment%2C%20elegant%20composition%20with%20rich%20textures&width=640&height=360&seq=media-02&orientation=landscape'
  },
  {
    title: '本周必看：高分新片速递', meta: '影评精选 / 观影指南', duration: '08:45', views: '56万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20with%20elegant%20warm%20lighting%2C%20film%20review%20studio%20aesthetic%2C%20soft%20coral%20and%20amber%20gradients%2C%20movie%20theater%20atmosphere%2C%20professional%20composition%20with%20rich%20textures&width=640&height=360&seq=media-03&orientation=landscape'
  },
  {
    title: '经典重温：长安十二时辰', meta: '深度解析 / 名场面', duration: '22:10', views: '203万',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20historical%20Chinese%20drama%20scene%20with%20warm%20lantern%20lighting%2C%20ancient%20city%20aesthetic%2C%20soft%20amber%20gradients%2C%20movie%20theater%20atmosphere%2C%20professional%20composition%20with%20rich%20textures&width=640&height=360&seq=media-04&orientation=landscape'
  },
];

export default function Media() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">编辑团队每日精选优质内容，为您推荐最值得看的影视佳作</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={item.title}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                {!imgErrors[idx] ? (
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => setImgErrors((prev) => ({ ...prev, [idx]: true }))}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-film-line text-3xl text-foreground-300"></i>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 right-2 bg-foreground-900/70 text-background-50 text-xs px-2 py-0.5 rounded-md">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm text-foreground-900 mb-1 line-clamp-1">{item.title}</h3>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{item.meta}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}